import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {NotificationCardComponent} from './notification-card/notification-card.component';
import {NotificationItemComponent} from './notification-item/notification-item.component';
import {RouterModule} from '@angular/router';
import {NotificationLinkComponent} from './notification-link/notification-link.component';

@NgModule({
  declarations: [NotificationCardComponent, NotificationItemComponent, NotificationLinkComponent],
  imports: [CommonModule, MatIconModule, RouterModule],
  exports: [NotificationCardComponent, NotificationItemComponent, NotificationLinkComponent],
})
export class NotificationModule {}
